import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useBusinesses(cityId, category = 'all', search = '', options = {}) {
  const { nearMe = false, position = null, radius = 5000 } = options;
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, pages: 0 });

  const fetchBusinesses = useCallback(async (page = 1) => {
    if (!cityId) return;
    setLoading(true);
    setError(null);
    try {
      const params = { city_id: cityId, page, limit: 20 };
      if (category && category !== 'all') {
        params.category = category;
      }
      if (search.trim()) {
        params.search = search.trim();
      }
      // "Perto de mim": filtra por raio geográfico (backend já calcula distance)
      if (nearMe && position?.lat != null && position?.lng != null) {
        params.lat = position.lat;
        params.lng = position.lng;
        params.radius = radius;
      }
      const { data } = await api.get('/businesses', { params });
      // API retorna { businesses: [...], pagination: {...} } ou array direto
      const list = data.businesses || data.data || (Array.isArray(data) ? data : []);
      setBusinesses(list);
      if (data.pagination) setPagination(data.pagination);
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erro ao carregar comércios');
      setBusinesses([]);
    } finally {
      setLoading(false);
    }
  }, [cityId, category, search, nearMe, position?.lat, position?.lng, radius]);

  useEffect(() => {
    if (cityId) fetchBusinesses(1);
  }, [cityId, category, search, fetchBusinesses]);

  const getBusinessById = useCallback(async (id) => {
    try {
      const { data } = await api.get(`/businesses/${id}`);
      return data.business || data;
    } catch {
      return null;
    }
  }, []);

  const createReview = useCallback(async (businessId, rating, comment) => {
    const { data } = await api.post(`/businesses/${businessId}/reviews`, { rating, comment });
    return data;
  }, []);

  return {
    businesses,
    loading,
    error,
    pagination,
    getBusinessById,
    createReview,
    refetch: fetchBusinesses,
  };
}
